import { useQuery } from '@tanstack/react-query';
import { getAgreements } from '../services/cartService';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FEATURE_FLAG_KEYS } from '../../../../../config/growthbook';

const AGREEMENTS_QUERY_KEY = '/api/resilience/v1/agreements';

export const useAgreements = () => {
  const crsEnableSelfServe = useFeatureIsOn(
    FEATURE_FLAG_KEYS.CRS_ENABLE_SELF_SERVE
  );

  return useQuery({
    queryKey: [AGREEMENTS_QUERY_KEY],
    queryFn: () => getAgreements().then((res) => res.data ?? []),
    refetchOnWindowFocus: true,
    enabled: crsEnableSelfServe,
  });
};

useAgreements.queryKey = AGREEMENTS_QUERY_KEY;
